export default{
	env:'dev',
	appName: 'nongtou-uni',
	apiBaseUrl: 'http://127.0.0.1:10076'
}